/** Leiste unten, sobald etwas geändert ist: Anzahl, Verwerfen, Speichern (nur mit Netz). */
export function Speichern({ anzahl, fehler, online, speichert, onVerwerfen, onSpeichern }) {
  if (!anzahl && !fehler) return null;
  return (
    <div className="savebar" role="region" aria-label="Änderungen speichern">
      {fehler && <div className="notice err" role="alert">{fehler}</div>}
      {!online && <div className="notice info" role="status">Offline – Speichern geht wieder mit Verbindung.</div>}
      {anzahl > 0 && (
        <div className="row">
          <span style={{ flex: 1, minWidth: 0, fontSize: 14, fontWeight: 700 }}>{anzahl === 1 ? '1 Änderung' : `${anzahl} Änderungen`}</span>
          <button type="button" className="btn secondary" style={{ padding: '0 14px' }} onClick={onVerwerfen} disabled={speichert}>Verwerfen</button>
          <button type="button" className="btn" style={{ padding: '0 16px' }} onClick={onSpeichern} disabled={speichert || !online}>{speichert ? 'Speichert …' : 'Speichern'}</button>
        </div>
      )}
    </div>
  );
}
